<template>
 
  <section class="faqs">
      <div class="container">
          <div class="titulos-iniciales">
            <div class="titulo">
                <h1>Preguntas <span>frecuentes</span> </h1>
            </div>
          </div>
          <div class="accordion mt-4">
              <Pregunta>
                <template v-slot:title>
                    <span class="accordion-title">¿Qué es Credix?</span>
                    <span class="icon" aria-hidden="false"></span>
                </template>
                <template v-slot:content>
                <p>
                    Credix una financiera y fiduciaria con más de 15 años de trayectoria en el sector financiero mexicano, ofreciendo alternativas de financiamiento, factoraje y servicios fiduciarios en comparativa de la banca tradicional o cualquier otra institución financiera.
                </p>
                <p>En Credix queremos ayudar a todas esas personas y PyMEs a fortalecer su capital de trabajo, brindarles liquidez inmediata o bien hacer realidad ese proyecto que tanto anhelan.</p>
                </template>
            </Pregunta>
            <Pregunta>
                <template v-slot:title>
                    <span class="accordion-title">¿Credix es un banco?</span>
                    <span class="icon" aria-hidden="false"></span>
                </template>
                <template v-slot:content>
                <p>
                    No, Credix no es un banco. Credix es una SOFOM no regulada, esto es una sociedad de Objeto Múltiple de acuerdo a la regulación de la CNBV. Nosotros no realización captación de depósitos del público en general.
                </p>
                </template>
            </Pregunta>
            <Pregunta>
                <template v-slot:title>
                    <span class="accordion-title">¿Credix se encuentra verificado ante la Condusef?</span>
                    <span class="icon" aria-hidden="false"></span>
                </template>
                <template v-slot:content>
                <p>
                    Claro que sí. Puedes corroborar nuestro registro ante la Condusef en el siguiente link: 
                    <a href="https://webapps.condusef.gob.mx/SIPRES/jsp/pub/index.jsp">https://webapps.condusef.gob.mx/SIPRES/jsp/pub/index.jsp</a> <br>
                    <br>
                    Pasos a seguir:
                    <ol>
                        <li>En el primer campo de búsqueda "Nombre o nombre corto" colocar "CREDIX GS"</li>
                        <li>Dar click en buscar y seleccionar "CREDIX GS, S.A. de C.V., SOFOM ENR" la cual es nuestra razón social</li>
                        <li>Se abrirá una ventana con nuestro registro donde el usuario podrá visualizar domicilio, estatus ante CONDUSEF, datos del representante legal, fecha de inicio de operaciones, entre muchos otros.</li>
                    </ol>
                    Nuestra <b>clave de registro</b> ante la CONDUSEF es: <b>690037</b> 

                </p>
                </template>
            </Pregunta>
            <Pregunta>
                <template v-slot:title>
                    <span class="accordion-title">Si estoy en buró de crédito ¿puedo aplicar a un préstamo con garantía inmobiliaria?</span>
                    <span class="icon" aria-hidden="false"></span>
                </template>
                <template v-slot:content>
                <p>
                    Sí, uno de nuestros diferenciadores en Credix es que el buró de crédito NO es determinante para obtener una línea de crédito con nosotros.
                </p>
                </template>
            </Pregunta>
            <Pregunta>
                <template v-slot:title>
                    <span class="accordion-title">¿Cómo funciona un crédito con garantía inmobiliaria?</span>
                    <span class="icon" aria-hidden="false"></span>
                </template>
                <template v-slot:content>
                <p>
                    Credix es una SOFOM enfocada en brindar líneas de crédito con garantía inmobiliaria. Esto es que todo solicitante nuestro utiliza un bien inmueble como una casa, departamento, oficina, edificio o terreno para garantizar el crédito.
                </p>
                <p>
                    Con este esquema accedes a montos de crédito superiores a los de la banca tradicional, mejores tasas de interés y plazos de préstamo más flexibles.
                </p>
                </template>
            </Pregunta>
            <Pregunta>
                <template v-slot:title>
                    <span class="accordion-title">¿Si no cuento con bien inmueble puedo solicitar un crédito?</span>
                    <span class="icon" aria-hidden="false"></span>
                </template>
                <template v-slot:content>
                <p>
                    No, actualmente no otorgamos préstamos sin un activo que lo respalde. Nuestros créditos están garantizados con un bien inmueble. Al ofrecer el activo en garantía, podemos ofrecer mejores montos, tasas de interés competitivas y plazos más flexibles.
                </p>
                </template>
            </Pregunta>
            <Pregunta>
                <template v-slot:title>
                    <span class="accordion-title">¿Puedo solicitar un préstamo si soy extranjero?</span>
                    <span class="icon" aria-hidden="false"></span>
                </template>
                <template v-slot:content>
                <p>
                   Si, si es posible que acreditemos a extranjeros en la financiera. Para efecto de lo anterior el cliente deberá de contar, cómo adicional a nuestros requerimientos originales: 
                     <br><br>
                      <ul>
                          <li>Contar con residencia permanente o temporal (antes FM3 y FM2).</li>
                          <li>Pasaporte vigente.</li>
                          <li>Acta de nacimiento de país de origen.</li>
                      </ul>
                </p>
                </template>
            </Pregunta>
            <Pregunta>
                <template v-slot:title>
                    <span class="accordion-title">¿En dónde se encuentran ubicados?</span>
                    <span class="icon" aria-hidden="false"></span>
                </template>
                <template v-slot:content>
                <p>
                    Actualmente contamos con oficinas de representación en CDMX, Guadalajara, Monterrey, Cancún y Chihuahua, puedes visitarnos en nuestros domicilios:
                </p>
                <p>
                    <ul>
                        <li>
                            <b>CDMX</b>: Miguel de Cervantes Saavedra No. 157 Piso 6, Col. Ampliación Granada, Miguel Hidalgo, CDMX. C.P. 11520
                        </li>
                        <li>
                             <b>Guadalajara</b>: Paseo de Los Virreyes No. 45, Piso 4, Interior 116, Puerta de Hierro, CP. 45116, Zapopan, Jal.
                        </li>
                        <li>
                             <b>Morelia</b>: Av. Camelinas No. 2650 Piso 4, Fracc. Prados del Campestre. Morelia, Michoacán. C.P. 58297
                        </li>
                        <li>
                             <b>Chihuahua</b>: California No. 4113, Quintas del Sol, CP. 31214, Chihuahua, Chih.

                        </li>
                        <li>
                             <b>Monterrey</b>: Deal Center, Av. Insurgentes No. 4474, Piso 3, Colinas de San Jerónimo, CP. 64630, Monterrey, N.L.
                        </li>
                        <li>
                             <b>Cancún</b>: IOS Offices Corporativo Malecon Americas Bonampak, SM6 MZ 1 LT 1 Piso 5, C.P. 77500 Cancún, Quintana Roo.
                        </li>
                    </ul>
                </p>
                <p>
                    Nuestras oficinas centrales y de la UNE se encuentran en Morelia, Michoacán en: <br><br> Periférico Paseo de la República No. 2650 P4 Int. 5, Prados del Campestre, CP. 58297, Morelia, Michoacán  <br><br>
                    Nuestro horario de atención es de lunes a viernes de 09:00 a.m. a 07:00 p.m.  <br>
                    Ponemos a tu disposición nuestros medios de contacto:
                    <br>
                    <ul>
                        <li>Corporativo: 800 467 2836 <br> Oficina Central CDMX: 55 4333 0223</li>
                        <li>WhatsApp: 55 3510 7320</li>
                        <li>hola@credix.com.mx</li>
                    </ul>
                </p>
                </template>
            </Pregunta>
        </div>
      </div>
  </section>
</template>

<script>
import Pregunta from "@/components/otros/Accordion";
export default {
components:{
    Pregunta
},
 methods:{
        
    }

}
</script>

<style lang="css">
    .faqs{
        margin: 4rem 0;
    }
</style>